'use strict';

var types = require('./lib/card-types');
var clone = require('./lib/clone');
var findBestMatch = require('./lib/find-best-match');
var isValidInputType = require('./lib/is-valid-input-type');
var addMatchingCardsToResults = require('./lib/add-matching-cards-to-results');
var testOrder;
var customCards = {};
var cardNames = {
  VISA: 'visa',
  MASTERCARD: 'mastercard',
  AMERICAN_EXPRESS: 'american-express',
  DINERS_CLUB: 'diners-club',
  DISCOVER: 'discover',
  JCB: 'jcb',
  UNIONPAY: 'unionpay',
  MAESTRO: 'maestro',
  ELO: 'elo',
  MIR: 'mir',
  HIPER: 'hiper',
  HIPERCARD: 'hipercard'
};
var ORIGINAL_TEST_ORDER = [cardNames.VISA, cardNames.MASTERCARD, cardNames.AMERICAN_EXPRESS, cardNames.DINERS_CLUB, cardNames.DISCOVER, cardNames.JCB, cardNames.UNIONPAY, cardNames.MAESTRO, cardNames.ELO, cardNames.MIR, cardNames.HIPER, cardNames.HIPERCARD];
testOrder = clone(ORIGINAL_TEST_ORDER);
function findType(type) {
  return customCards[type] || types[type];
}
function getAllCardTypes() {
  return testOrder.map(function (type) {
    return clone(findType(type));
  });
}
function getCardPosition(name, ignoreErrorForNotExisting) {
  var position = testOrder.indexOf(name);
  if (!ignoreErrorForNotExisting && position === -1) {
    throw new Error('"' + name + '" is not a supported card type.');
  }
  return position;
}
function creditCardType(cardNumber) {
  var bestMatch;
  var results = [];
  if (!isValidInputType(cardNumber)) {
    return [];
  }
  if (cardNumber.length === 0) {
    return getAllCardTypes(testOrder);
  }
  testOrder.forEach(function (type) {
    var cardConfiguration = findType(type);
    addMatchingCardsToResults(cardNumber, cardConfiguration, results);
  });
  bestMatch = findBestMatch(results);
  if (bestMatch) {
    return [bestMatch];
  }
  return results;
}
creditCardType.getTypeInfo = function (type) {
  return clone(findType(type));
};
creditCardType.removeCard = function (name) {
  var position = getCardPosition(name);
  testOrder.splice(position, 1);
};
creditCardType.addCard = function (config) {
  var existingCardPosition = getCardPosition(config.type, true);
  customCards[config.type] = config;
  if (existingCardPosition === -1) {
    testOrder.push(config.type);
  }
};
creditCardType.updateCard = function (cardType, updates) {
  var clonedCard;
  var originalObject = customCards[cardType] || types[cardType];
  if (!originalObject) {
    throw new Error('"' + cardType + '" is not a recognized type. Use `addCard` instead.');
  }
  if (updates.type && originalObject.type !== updates.type) {
    throw new Error('Cannot overwrite type parameter.');
  }
  clonedCard = clone(originalObject, true);
  Object.keys(clonedCard).forEach(function (key) {
    if (updates[key]) {
      clonedCard[key] = updates[key];
    }
  });
  customCards[clonedCard.type] = clonedCard;
};
creditCardType.changeOrder = function (name, position) {
  var currentPosition = getCardPosition(name);
  testOrder.splice(currentPosition, 1);
  testOrder.splice(position, 0, name);
};
creditCardType.resetModifications = function () {
  testOrder = clone(ORIGINAL_TEST_ORDER);
  customCards = {};
};
creditCardType.types = cardNames;
module.exports = creditCardType;